<div class="modal-title">
    <span>{{'units.device.set_project'|translate}}</span>
    <span class="trace-spacer"></span>

    <lib-button icon="close" color="none" textColor="muted" (click)="dialogRef.close()">
    </lib-button>
</div>

<div class="tracker-list">
    @if(trackers){
    <div class="chip-list">
        @for( tracker of trackers;track tracker.id){
        <lib-chip color="muted" [text]="tracker.name" icon="track_changes">
        </lib-chip>
        }
    </div>
    }
</div>

<mat-form-field>
    <mat-label>{{'projects.list'|translate}} </mat-label>

    <mat-select [(ngModel)]="projectId">
        @for(project of projects; track project.id){
        <mat-option [value]="project.id">{{project.name}}</mat-option>
        }
    </mat-select>
</mat-form-field>

<mat-dialog-actions class="dialog-actions">
    <span class="trace-spacer"></span>

    <lib-button color="outline" icon="close" (click)="dialogRef.close()"
        text="{{'form.cancel'|translate}}"></lib-button>
    <lib-button color="primary" icon="save" (click)="setProject()" text="{{'form.save'|translate}}"></lib-button>
</mat-dialog-actions>